import { AquagymLanding } from "./pages/AquagymLanding";
export function App() {
  return <AquagymLanding data-id="element-0" data-mp="odhpb5nlkyd3" />;
}